import React from 'react';
import {isInBrowser} from '../utils/browser/isInBrowser';

export function useUrlHash(): string | undefined {
    const getUrlHash = () =>
        isInBrowser() ? window.location.hash.slice(1) : undefined;

    const [urlHash, setUrlHash] = React.useState(getUrlHash());

    React.useEffect(() => {
        const handleHashChange = () => {
            const newHash = getUrlHash();
            if (newHash === urlHash) return;

            setUrlHash(newHash);
        };

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [urlHash]);

    return urlHash;
}
